import Request from "./request";

const Collection = "/user/collections";

export default {
  //收藏接口
  async getCollection(query) {
    return Request.get(`${Collection}/${query.type}`, query);
  },
  async getCollectionId(query) {
    return Request.get(`${Collection}/${query.type}/${query.id}`, query);
  },
  async createCollection(query) {
    return Request.post(Collection, query);
  },
  async deleteCollection(query) {
    return Request.delete(`${Collection}/${query.id}`, query);
  }
};
